
export default function GuideButton(props) {
    const {
        onClick = () => { }
    } = props;

    return <div className="mobileviewnone" style={{
        position: "fixed",
        width: 114,
        textAlign: "center",
        right: "23px",
        bottom: "10px",
        padding: "5px 0px",
        borderRadius: 5,
        color: "#FFF",
        background: "#C3C6CA",
        zIndex: 1100,
        fontSize: 14,
        fontWeight: 700,
        cursor: "pointer"
    }} onClick={onClick}>
        이용가이드
    </div>
}